import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import MaskedInput from 'react-text-mask';
import Input from '../Input';

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      placeholderChar={'\u2000'}
      showMask={false}
      guide={false}
      {...other}
    />
  );
}

export const renderInput = ({ input, meta: { touched, invalid, error }, ...props }) => (
  <Input
    error={touched && invalid}
    helperText={touched && error}
    onChange={input.onChange}
    {...input}
    {...props}
    InputProps={{
      inputComponent: TextMaskCustom,
      inputProps: { mask: props.mask },
    }}
  />
);

renderInput.propTypes = {
  input: PropTypes.shape({}),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }),
};

renderInput.defaultProps = {
  input: {},
  meta: {},
};

const FormInput = ({ name, ...props }) => <Field name={name} component={renderInput} {...props} />;

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormInput;
